<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";

export default defineComponent({
  name: "FundForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: {
          uz_cyr: null,
          uz_lat: null,
          kr: null,
          en: null,
          ru: null
        }
      },
      rules: {
        title: {
          uz_lat: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          uz_cyr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          ru: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          en: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          kr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        }
      }
    }
  },
  methods: {
    getFundById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/funds/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/funds/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/funds", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getFundById()
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="O'zbekcha nomi" prop="title.uz_lat">
                <el-input type="text" v-model="form.title.uz_lat"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="O'zbek-kirilcha nomi" prop="title.uz_cyr">
                <el-input type="text" v-model="form.title.uz_cyr"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Ruscha nomi" prop="title.ru">
                <el-input type="text" v-model="form.title.ru"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Inglizcha nomi" prop="title.en">
                <el-input type="text" v-model="form.title.en"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Qoraqalpoqcha nomi" prop="title.kr">
                <el-input type="text" v-model="form.title.kr"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>

</style>
